import { ACTIONS_KASPI } from '../actions/kaspi';

export const kaspi = (state = {}, action) => {
  switch (action.type) {
    case ACTIONS_KASPI.ADD_PRODUCTS: {
      return { ...state, ...action.data };
    }
    case ACTIONS_KASPI.CHANGE_PRODUCT: {
      const { product } = action;
      return { ...state, byId: { ...state.byId, [product.offer_id]: { ...product } } };
    }
    case ACTIONS_KASPI.CHANGE_MARKET: {
      const { market } = action;
      return { ...state, market };
    }
    default:
      return state;
  }
};
